module.exports = __webpack_public_path__ + "img/kiwoom_main_right1.9308e407.png";